const Mock = require("mockjs");
const Random = require("mockjs").Random;

Mock.mock("http://localhost:1314/mock/gsyyfx/getSaleCount", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      count: "1,000,000.00",
      finishingRate: "55.55",
    },
  };
});
Mock.mock("http://localhost:1314/mock/gsyyfx/getDSAverdata", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      aver: "1,000,000.00",
      averList: {
        xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
        series: [1200, 1861, 4952, 990, 775, 3544, 2200],
      },
    },
  };
});
Mock.mock("http://localhost:1314/mock/gsyyfx/salesKitList", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: [
      {
        gjlxName: "电话调查",
        gjcs: 12,
      },
      {
        gjlxName: "客户交流",
        gjcs: 12,
      },
      {
        gjlxName: "商务推进",
        gjcs: 12,
      },
      {
        gjlxName: "客户接待",
        gjcs: 12,
      },
      {
        gjlxName: "客户拜访",
        gjcs: 12,
      },
      {
        gjlxName: "客户签约",
        gjcs: 12,
      },
      {
        gjlxName: "项目催款",
        gjcs: 12,
      },
      {
        gjlxName: "危机公关",
        gjcs: 12,
      },
      {
        gjlxName: "其余其他",
        gjcs: 12,
      },
    ],
  };
});
const dsCount = [12, 18, 49, 99, 77, 35, 22].reverse();
Mock.mock("http://localhost:1314/mock/gsyyfx/getDSPercent", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
      dsMoney: [12, 18, 49, 99, 77, 35, 22],
      dsCount,
    },
  };
});
Mock.mock("http://localhost:1314/mock/gsyyfx/getHtCount", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      xAxis: {
        dataList: [
          "产品",
          "创新业务",
          "数据服务",
          "基础软件服务",
          "开发+推广",
          "管理咨询",
          "战略项目",
          "规划咨询",
          "培训",
          "软件开发",
          "三位一体",
          "技术服务",
          "小三位一体",
          "云平台",
          "应用推广",
          "咨询+开发",
          "信息化咨询",
        ],
        legend: "",
      },
      count: 1222,
      onserve: 1222,
      ydata1: {
        dataList: [
          221,
          952,
          543,
          456,
          1123,
          2241,
          622,
          1024,
          562,
          781,
          355,
          541,
          888,
          999,
          774,
          259,
          477,
        ],
        legend: "总数",
      },
      ydata2: {
        dataList: [
          182,
          95,
          54,
          45,
          123,
          241,
          62,
          104,
          52,
          81,
          55,
          51,
          88,
          99,
          77,
          59,
          77,
        ],
        legend: "服务中",
      },
    },
  };
});
Mock.mock("http://localhost:1314/mock/gsyyfx/getGshkCount", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: [
      {
        time: "月",
        hkje: "1520211", //公司回款金额
        ysws: "200143", // 应收未收
        wcl: "13.16%",
      },
      {
        time: "季",
        hkje: "4100053", //公司回款金额
        ysws: "720015", // 应收未收
        wcl: "15.16%",
      },
      {
        time: "年",
        hkje: "21100321", //公司回款金额
        ysws: "3200143", // 应收未收
        wcl: "18.16%",
      },
    ],
  };
});

Mock.mock("http://localhost:1314/mock/gsyyfx/getFgshkData", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: [
      {
        name: "分公司回款排行",
        xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
        series: [1200, 1861, 4952, 990, 775, 3544, 2200],
      },
      {
        name: "分公司应收未收排行",
        xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
        series: [120, 181, 452, 390, 575, 344, 220],
      },
      {
        name: "分公司回款完成率排行",
        xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
        series: [12, 18, 49, 99, 77, 35, 22],
      },
    ],
  };
});

Mock.mock("http://localhost:1314/mock/gsyyfx/getFgsAver", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
      averList: [
        {
          time: "月",
          series: [90, 70, 10, 22, 150, 30, 70],
        },
        {
          time: "季",
          series: [120, 181, 452, 390, 575, 344, 220],
        },
        {
          name: "年",
          series: [900, 1000, 1200, 600, 1000, 1500, 900],
        },
      ],
    },
  };
});
//项目成本
Mock.mock("http://localhost:1314/mock/gsyyfx/getXmcb", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      name: [
        "对公活期存款利润",
        "差旅补贴",
        "交通费",
        "房租",
        "通讯费",
        "项目费用",
        "采购费用",
        "其他费用",
      ],
      list: [
        {
          time: "月",
          mnlr: "443万",
          detail: [
            {
              bmbh: 0,
              bmmc: "公司",
              data: [
                { value: 1048, name: "对公活期存款利润" },
                { value: 335, name: "差旅补贴" },
                { value: 310, name: "交通费" },
                { value: 251, name: "房租" },
                { value: 234, name: "通讯费" },
                { value: 147, name: "项目费用" },
                { value: 135, name: "采购费用" },
                { value: 102, name: "其他费用" },
              ],
            },
            {
              bmbh: 1,
              bmmc: "广州",
              data: [
                { value: 18, name: "对公活期存款利润" },
                { value: 35, name: "差旅补贴" },
                { value: 30, name: "交通费" },
                { value: 21, name: "房租" },
                { value: 24, name: "通讯费" },
                { value: 47, name: "项目费用" },
                { value: 35, name: "采购费用" },
                { value: 10, name: "其他费用" },
              ],
            },
          ],
        },
        {
          time: "季",
          series: [120, 181, 452, 390, 575, 344, 220],
        },
        {
          name: "年",
          series: [900, 1000, 1200, 600, 1000, 1500, 900],
        },
      ],
    },
  };
});

Mock.mock("http://localhost:1314/mock/gsyyfx/getLldPercent", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: {
      xAxis: ["广州", "南京", "沈阳", "北京", "西安", "太原", "济南"],
      series: [12, 18, 49, 99, 77, 35, 22],
      count: 45,
    },
  };
});
//最佳模型执行情况
Mock.mock("http://localhost:1314/mock/gsyyfx/getZjmxzxqk", "get", () => {
  return {
    code: 0,
    msg: "操作成功",
    data: [
      {
        mc: "客户1",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户2",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户3",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户4",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户5",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户6",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户7",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户8",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户9",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户10",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户11",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户12",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户13",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户14",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户15",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
      {
        mc: "客户16",
        zxcs: "1 ",
        zxxms: "5人/日",
        jhgzl: "4.35",
        dzzxgzl: "4.35",
        zxrs: "4.35",
      },
    ],
  };
});
